import { meSchema } from "../../../lib/types/schema/user/meSchema";
import type { RequestProps } from "../../../request/request";
import { request } from "../../../request/request";

export const requestMeProps = {
  schema: meSchema,
  urlBackendPath: "/me",
};

export type RequestMeProps = Omit<RequestProps, "url">;

export const requestMe = ({ ...props }: RequestMeProps = {}) =>
  request({
    ...props,
    ...requestMeProps,
  });
